import React from "react";

import AdminThumbnail from "../../../assets/imgs/thumbnail-admin.png";
import ManagerThumbnail from "../../../assets/imgs/thumbnail-manager.png";
import TechThumbnail from "../../../assets/imgs/thumbnail-tech.png";
import VetThumbnail from "../../../assets/imgs/thumbnail-vet.png";
import { useRole } from "../../../hooks/use-role";
import RoleOptionCard from "../RoleOptionCard";
import StepWrapper from "../StepWrapper";

export default function RoleStep({ selectedRole, setSelectedRole }) {
  const { allowedRoles } = useRole();
  const userOptions = [
    {
      title: "Veterinarian",
      img: VetThumbnail,
      value: allowedRoles.DVM,
    },
    {
      title: "Vet Tech",
      img: TechThumbnail,
      value: allowedRoles.TECHNICIAN,
    },
    {
      title: "Practice Manager",
      img: ManagerThumbnail,
      value: allowedRoles.PRACTICE_MANAGER,
    },
    {
      title: "Clinic Admin/Other",
      img: AdminThumbnail,
      value: allowedRoles.OTHER,
    },
  ];

  return (
    <div className="flex flex-col items-center sm:justify-center h-full w-full">
      <StepWrapper
        title="Which option best represents your role?"
        description="This will help us tailor your onboarding experience."
        withBackground={false}
      >
        <div className="flex flex-wrap gap-2 md:gap-6 md:flex-row justify-center text-center h-full sm:h-auto">
          {userOptions.map((option) => (
            <RoleOptionCard
              key={option.value}
              title={option.title}
              img={option.img}
              value={option.value}
              isSelected={selectedRole === option.value}
              onSelect={setSelectedRole}
              dataTestId={`role-option-${option.title}`}
            />
          ))}
        </div>
      </StepWrapper>
    </div>
  );
}
